import { FETCH_RECENT_POSTS_SUCCESS } from '../../../post-page/actions/fetch-recent-posts';
import { FETCH_SEARCH_SUCCESS } from '../../../search/actions/fetch-search-types';
import { FETCH_ARCHIVE_SUCCESS } from '../../actions/fetch-archive';
import { FETCH_CATEGORY_POSTS_SUCCESS } from '../../actions/fetch-category-posts';
import { FETCH_FEED_METADATA_SUCCESS } from '../../actions/fetch-feed-metadata';
import { FETCH_FEED_POSTS_SUCCESS } from '../../actions/fetch-feed-posts';
import { FETCH_HASHTAG_POSTS_SUCCESS } from '../../actions/fetch-hashtag-posts';
import { FETCH_POST_SUCCESS } from '../../actions/fetch-post';
import { fetchPostListMetadataSuccess } from '../../actions/fetch-post-list-metadata';
import { FETCH_TAG_POSTS_SUCCESS } from '../../actions/fetch-tag-posts';
import { PUBLISH_POST_SUCCESS } from '../../actions/publish-post-types';
import { SAVE_POST_DRAFT_SUCCESS } from '../../actions/save-post-draft-types';
import { SET_POSTS } from '../../actions/set-posts';
import { UPDATE_POST_SUCCESS } from '../../actions/update-post';
import { enhancePostsWithMetadata } from '../../services/post-utils';
import { fetchCurrentUserSuccess } from '../auth/fetch-current-user';

const unionPosts = (oldPosts, newPosts) =>
  newPosts.reduce(
    (result, post) => {
      result[post.id] = post;
      return result;
    },
    { ...oldPosts },
  );

const postWithOwner = (state, action) => {
  switch (action.type) {
    case fetchCurrentUserSuccess.type:
      if (state.owner?.siteMemberId === action.payload.siteMemberId) {
        return { ...state, owner: { ...state.owner, ...action.payload } };
      }
      return state;
    default:
      return state;
  }
};

const posts = (state = {}, { type, payload } = {}) => {
  switch (type) {
    case SET_POSTS:
      return unionPosts({}, payload);
    case FETCH_POST_SUCCESS:
      return unionPosts(state, [payload.post]);
    case FETCH_FEED_POSTS_SUCCESS:
    case FETCH_RECENT_POSTS_SUCCESS:
    case FETCH_CATEGORY_POSTS_SUCCESS:
    case FETCH_ARCHIVE_SUCCESS:
    case FETCH_HASHTAG_POSTS_SUCCESS:
    case FETCH_TAG_POSTS_SUCCESS:
      return unionPosts(state, payload);
    case UPDATE_POST_SUCCESS:
      return unionPosts(state, [payload]);
    case PUBLISH_POST_SUCCESS:
      return unionPosts(state, [payload]);

    case SAVE_POST_DRAFT_SUCCESS:
      return unionPosts(state, [payload?.post]);

    case FETCH_SEARCH_SUCCESS:
      return unionPosts(state, payload.posts);
    case fetchCurrentUserSuccess.type:
      return Object.keys(state).reduce((result, current) => {
        result[current] = postWithOwner(state[current], { type, payload });
        return result;
      }, {});
    case FETCH_FEED_METADATA_SUCCESS:
    case fetchPostListMetadataSuccess.type:
      return unionPosts(
        state,
        enhancePostsWithMetadata({
          posts: Object.values(state),
          postMetricsMap: payload.postFeedMetadataPage?.postMetrics ?? {},
          postLikesMap: payload.postFeedMetadataPage?.postLikes ?? {},
        }),
      );
    default:
      return state;
  }
};

export default posts;
